import statusesId from '@/constants/statusesId';

export default {
    data: () => ({
        statusesId
    }),
    computed: {
        similarFamilies () {
            return this.$store.getters['familyData/getSimilarFamilies'];
        },
        formattedSimilarFamilies () {
            return this.$store.getters['familyData/getFormattedSimilarFamilies'];
        },
        notAttributedFamilies () {
            return this.formattedSimilarFamilies.filter((el) => el.primary_volunteer_assigned === false);
        },
        othersFamilies () {
            return this.formattedSimilarFamilies.filter((el) => el.primary_volunteer_assigned === true);
        },
        cannotOverwriteFamily () {
            return (
                this.chosenOption === 2 &&
        this.chosenFamily === -1 &&
        this.formattedSimilarFamilies.length === 1 &&
        this.notAttributedFamilies.length === 0
            );
        },
        noFamiliesForOverwrite () {
            return (
                this.chosenOption === 2 &&
        this.chosenFamily === -1 &&
        this.formattedSimilarFamilies.length > 1 &&
        this.notAttributedFamilies.length === 0
            );
        },
        canOverwriteFamily () {
            if (this.chosenOption === 2) {
                if (this.chosenFamily === -1) {
                    return this.overwriteFamily != null;
                }
                return this.chosenFamily != null;
            }
            return true;
        }
    }
};
